var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Stack, Stepper, Step, StepLabel, StepConnector, stepConnectorClasses, } from '@mui/material';
import { OkIcon } from '../atoms/Icons';
import { FormTypeValues } from './OrderForm';
var QontoConnector = styled(StepConnector)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(stepConnectorClasses.alternativeLabel)] = {
            top: 10,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
        },
        _b["&.".concat(stepConnectorClasses.active)] = (_c = {},
            _c["& .".concat(stepConnectorClasses.line)] = {
                borderColor: theme.customPalette.primary.main,
            },
            _c),
        _b["&.".concat(stepConnectorClasses.completed)] = (_d = {},
            _d["& .".concat(stepConnectorClasses.line)] = {
                borderColor: theme.palette.success.main,
            },
            _d),
        _b["& .".concat(stepConnectorClasses.line)] = {
            borderRadius: 1,
            borderTopWidth: 3,
            borderColor: theme.palette.divider,
        },
        _b);
});
var QontoStepIconRoot = styled('div')(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return (__assign(__assign({ height: 22, display: 'flex', alignItems: 'center', color: theme.palette.text.disabled }, (ownerState.active && {
        color: theme.palette.success.main,
    })), { '& .QontoStepIcon-completedIcon': {
            zIndex: 1,
            fontSize: 18,
            color: theme.palette.success.main,
        }, '& .QontoStepIcon-circle': {
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: 'currentColor',
        } }));
});
function QontoStepIcon(props) {
    var active = props.active, completed = props.completed, className = props.className;
    return (React.createElement(QontoStepIconRoot, { ownerState: { active: active }, className: className }, completed ? (React.createElement(OkIcon, { className: "QontoStepIcon-completedIcon" })) : (React.createElement("div", { className: "QontoStepIcon-circle" }))));
}
var OrderFormStepper = function (_a) {
    var activeStep = _a.activeStep;
    var t = useTranslation().t;
    return (React.createElement(Stack, { sx: { width: '100%', mt: 5, mb: 2 }, spacing: 4 },
        React.createElement(Stepper, { alternativeLabel: true, activeStep: FormTypeValues.indexOf(activeStep), connector: React.createElement(QontoConnector, null) }, FormTypeValues.map(function (label) { return (React.createElement(Step, { key: label },
            React.createElement(StepLabel, { StepIconComponent: QontoStepIcon }, t("pages.typicaSelection.orderFormStepper.".concat(label))))); }))));
};
export default OrderFormStepper;
